<template>
  <div>
    <!-- <div class="user-name">
      {{ userInfo ? userInfo.username : '-' }}
    </div> -->
    <el-menu class="navbar" mode="horizontal">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened"
      ></hamburger>
      <breadcrumb></breadcrumb>

      <!-- <el-autocomplete
        class="inline-input"
        style="position: absolute; right: 160px; width: 160px"
        v-model="querySearchData"
        :fetch-suggestions="querySearch"
        placeholder="输入菜单名或路径"
        @select="handleSelect"
      ></el-autocomplete> -->
      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <div class="user-name">
            <span class="clock">{{ clock }}</span>
            <span
              :class="{
                'transform-huerotate transform-back-btn super-admin-login':
                  loginToken,
              }"
              >{{ userInfo ? userInfo.username : "-" }} (
              {{ userInfo ? translateUserType(userInfo.userType) : "" }} )

              <el-tag
                size="mini"
                type="danger"
                v-if="loginToken && userInfo.loginExpiredTime !== 0"
                ><span style="font-weight: 600"></span>
                {{
                  userInfo.loginExpiredTime === -1
                    ? "已逾期"
                    : `${userInfo.loginExpiredTime} 天后逾期`
                }}</el-tag
              >
            </span>
            <!-- <el-avatar
              v-bind:style="
                getAvatarColor(
                  userInfo ? userInfo.username.charAt(0).toUpperCase() : 'A'
                )
              "
              >{{
                userInfo
                  ? translateUserType(userInfo.userType).substring(0, 2)
                  : "-"
              }}</el-avatar
            > -->
          </div>
          <!-- <img class="user-avatar" :src="userInfo.icon"> -->
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <!-- <router-link class="inlineBlock" to="/setting/general">
            <el-dropdown-item>
              系统设置
            </el-dropdown-item>
          </router-link> -->
          <!-- <el-dropdown-item divided>
            身份：{{ userInfo ? userInfo.userType : '-' }}
          </el-dropdown-item> -->
          <!-- <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              天汇
            </el-dropdown-item>
          </router-link> -->
          <!-- <el-dropdown-item divided>
            版號：{{ userInfo.userType }}
          </el-dropdown-item> -->
          <!-- <el-dropdown-item>
            <span style="display: block"
              >{{ userInfo ? userInfo.username : "-" }} (
              {{ userInfo ? translateUserType(userInfo.userType) : "" }} )</span
            >
          </el-dropdown-item> -->
          <el-dropdown-item>
            <span
              @click="passwordDialogObj = { visible: true }"
              style="display: block"
              >密码设置</span
            >
          </el-dropdown-item>
          <el-dropdown-item>
            <span
              @click="employeeLogout"
              style="display: block"
              v-if="userInfo.userType === 'kefu'"
              >{{ employeeName }} 登出</span
            >
            <span @click="logout" style="display: block" v-else>登出管理</span>
          </el-dropdown-item>
          <!-- 重设记事本，审核员仍走旧的介面 -->
          <el-dropdown-item
            v-if="['credential_auditor'].indexOf(userInfo.userType) === -1"
          >
            <span @click="resetSticky()" style="display: block"
              >重设记事本</span
            >
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-menu>
    <!-- <StickyNote /> -->
    <!-- <Communication
      v-if="
        ['customer', 'operator'].indexOf(userInfo.userType) !== -1 ||
        (['admin'].indexOf(userInfo.userType) !== -1 &&
          userInfo.roles.indexOf('message_admin') !== -1)
      "
    /> -->
    <ArbitrateUpload />

    <!-- 公告 -->
    <Marquee />

    <!-- 修改密码 -->
    <PasswordDialog :password-dialog-obj.sync="passwordDialogObj" />
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import methodCommon from "@/utils/methodCommon";
import { mapGetters } from "vuex";
import Marquee from "./Marquee";
// import StickyNote from "./StickyNote";
// import Communication from "./communication";
import ArbitrateUpload from "@/views/components/dialog/ArbitrateUpload";
import PasswordDialog from "@/views/profile/my/PasswordDialog";
import {
  clockOutEmployee, // 结束员工值班
} from "@/api/user";
import Cookies from "js-cookie";
export default {
  mixins: [methodCommon],
  components: {
    PasswordDialog,
    Breadcrumb,
    Hamburger,
    // StickyNote,
    // Communication,
    ArbitrateUpload,
    Marquee,
  },
  computed: {
    ...mapGetters(["sidebar", "userInfo", "routers"]),
  },
  created() {
    this.getClock();
  },
  data() {
    return {
      searchRouters: [],
      // querySearchData: "",
      passwordDialogObj: {}, // 修改密码 obj
      employeeName: null,
      clockInterval: null,
      clock: null,
      systemTime: null,
      loginToken: localStorage.getItem("loginToken") || null, // 变身状态
    };
  },
  watch: {
    "$store.state.login.employeeObj.employeeName"(val) {
      this.employeeName = val;
    },
    "$store.state.app.unallocatedObj.systemTime"(val) {
      this.systemTime = val;
    },
  },
  methods: {
    // 改变头像背景颜色
    getAvatarColor(char) {
      let uid = "ABCDEFGHIJKLMNOPQRSTUVXYZ0123456789";
      let colorArray = [
        "#EE6B00",
        "#F14B2C",
        "#FCBB00",
        "#F3389F",
        "#788F9C",
        "#24C1DF",
        "#4085F3",
      ];
      return `background: ${colorArray[uid.indexOf(char) % colorArray.length]}`;
    },
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload();
      });
    },
    // 员工下班，直接登出
    employeeLogout() {
      clockOutEmployee({ userId: this.userInfo.userId })
        .then(() => {
          Cookies.remove("eeyolpme");
          location.reload();
        })
        .catch(() => {
          this.logout();
        });
    },
    // 来做个搜索框吧
    querySearch(queryString, cb) {
      this.searchRouters = this.loadAllRouterList();
      var searchRouters = this.searchRouters;
      var results = queryString
        ? searchRouters.filter(this.createFilter(queryString))
        : searchRouters;
      cb(results);
    },
    createFilter(queryString) {
      // value、path 都可以作为搜索条件
      return (searchRouter) => {
        return (
          searchRouter.value
            .toLowerCase()
            .includes(queryString.toLowerCase()) ||
          searchRouter["path"].toLowerCase().includes(queryString.toLowerCase())
        );
      };
    },
    loadAllRouterList() {
      let returnRouterArray = [];
      if (this.routers) {
        this.routers.forEach((element) => {
          if (element.meta && element.meta.title) {
            if (element.children) {
              element.children.forEach((el) => {
                returnRouterArray.push({
                  value: el.meta.title,
                  path: element.path + "/" + el.path,
                });
              });
            }
          }
        });
      }
      return returnRouterArray;
    },
    // handleSelect(item) {
    //   this.$router.push(item.path);
    //   this.querySearchData = "";
    // },
    getClock() {
      this.clockInterval = setInterval(() => {
        this.clock = this.formatTime(this.systemTime);
        this.systemTime += 1000; // 每秒钟增加 1000 毫秒
      }, 1000);
    },
    formatTime(timestamp) {
      let date = new Date(timestamp);
      let options = {
        timeZone: "Asia/Shanghai",
        hour12: true,
        // month: "short",
        // day: "numeric",
        // weekday: "short",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
      };
      return date.toLocaleString("zh-CN", options);
    },
    resetSticky() {
      this.$confirm("重设记事本将会刷新页面", "重设记事本", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          localStorage.removeItem(`sticky-${this.userInfo.userId}`);
          window.location.reload();
        })
        .catch(() => {});
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  position: relative;
  width: 100%;
  left: 0;
  z-index: 1025;
  top: 0;
  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  .screenfull {
    position: absolute;
    right: 90px;
    top: 16px;
    color: red;
  }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
    .avatar-wrapper {
      cursor: pointer;
      margin-top: 0px;
      position: relative;
      .el-avatar {
        color: #ffeba4;
      }
      .user-name {
        font-weight: 400;
        font-size: 13px;
      }
      .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
      }
      .el-icon-caret-bottom {
        position: absolute;
        right: -20px;
        top: 20px;
        font-size: 12px;
      }
    }
  }
  .super-admin-login {
    color: #f56c6c;
    padding: 10px 16px;
  }
  .clock {
    color: #848484;
    font-size: 15px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue